__turbopack_context__.v({
  "col": "BlockFlipDeck-module-scss-module__Zwrzsq__col",
  "dots": "BlockFlipDeck-module-scss-module__Zwrzsq__dots",
  "inner": "BlockFlipDeck-module-scss-module__Zwrzsq__inner",
  "mediaWrapper": "BlockFlipDeck-module-scss-module__Zwrzsq__mediaWrapper",
  "nav": "BlockFlipDeck-module-scss-module__Zwrzsq__nav",
  "navArrow": "BlockFlipDeck-module-scss-module__Zwrzsq__navArrow",
  "root": "BlockFlipDeck-module-scss-module__Zwrzsq__root",
});
